import React from 'react';
import { motion, useScroll, useTransform, useReducedMotion } from 'framer-motion';
import { ArrowDownIcon } from 'lucide-react';
import { GlassButton, GlassWhatsApp } from './ContactButtons';
import { contact } from '../data/site';
export function Hero() {
  const {
    scrollY
  } = useScroll();
  const reduce = useReducedMotion();
  const bgY = useTransform(scrollY, [0, 900], [0, reduce ? 0 : 200]);
  const bgScale = useTransform(scrollY, [0, 900], [1.06, reduce ? 1.06 : 1.18]);
  return <section id="inicio" className="relative flex min-h-[100svh] w-full items-center overflow-hidden bg-ink pb-16 pt-36" data-id="element-78" data-mp="xanpc0x21jfw">
      <motion.img src="https://cdn.magicpatterns.com/patterns/generated-images/44685df5-a358-4d1d-a44f-086307570573.jpg" alt="Altar ceremonial con velas doradas encendidas y candelabros antiguos" style={{
      y: bgY,
      scale: bgScale
    }} className="absolute inset-0 h-full w-full object-cover" data-id="element-79" data-mp="s9zwrat6gujk" />
      <div className="absolute inset-0 bg-gradient-to-br from-ink/95 via-ink/70 to-[#3a2503]/70" data-id="element-80" data-mp="384jud2bfbpui" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_35%,rgba(242,194,48,0.22),transparent_60%)]" data-id="element-81" data-mp="3j6fwnlhhz5bq" />
      <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-b from-transparent to-ink" data-id="element-82" data-mp="39acwgl67hgrf" />

      <div className="relative mx-auto grid w-full max-w-7xl gap-10 px-5 lg:grid-cols-[minmax(0,1fr)_auto] lg:items-end" data-id="element-83" data-mp="3e9fqzbok84l5">
        <div className="max-w-3xl" data-id="element-84" data-mp="30hrgtdxvfq6t">
          <motion.p initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          ease: [0.23, 1, 0.32, 1]
        }} className="font-sans text-xs font-medium uppercase tracking-[0.35em] text-gold-light/80" data-id="element-85" data-mp="30ggab6d1k4c0">
            Tradición de Catemaco &amp; la India
          </motion.p>

          <motion.h1 initial={{
          opacity: 0,
          y: 28
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.9,
          delay: 0.1,
          ease: [0.23, 1, 0.32, 1]
        }} className="mt-6 font-serif text-[2.6rem] font-semibold uppercase leading-[1.02] tracking-tight text-white sm:text-6xl lg:text-[5.2rem]" data-id="element-86" data-mp="2hind8kp3momj">
            Recupera el amor con{' '}
            <span className="animate-gold-pulse text-gold-light" data-id="element-87" data-mp="ibyo48aw4u02">conjuros ancestrales</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.25,
          ease: [0.23, 1, 0.32, 1]
        }} className="mt-7 max-w-xl font-sans text-lg leading-relaxed text-white/75" data-id="element-88" data-mp="ddwwv03b9odi">
            Maestros con experiencia real te acompañan para atraer y recuperar el amor que deseas.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4,
          ease: [0.23, 1, 0.32, 1]
        }} className="mt-10 flex flex-col items-center gap-4 sm:flex-row sm:flex-wrap sm:justify-start" data-id="element-89" data-mp="x030kujco9ae">
            <GlassButton href="#contacto" tone="gold" data-id="element-90" data-mp="1xam6ou2m9x0i">
              Consulta Gratis
            </GlassButton>
            <GlassWhatsApp data-id="element-91" data-mp="21bfttl88j7sc">Habla con un Maestro</GlassWhatsApp>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="hidden w-64 rounded-3xl border border-white/10 bg-white/5 p-6 shadow-[0_30px_80px_-30px_rgba(0,0,0,0.9)] backdrop-blur-md lg:block" data-id="element-92" data-mp="268g2m3wgyon5">
          <p className="font-serif text-4xl text-gold-light" data-id="element-93" data-mp="2p0qnkir641wz">+20</p>
          <p className="mt-1 font-sans text-sm text-white/70" data-id="element-94" data-mp="2p1a9eajxvaga">años de trabajo espiritual acompañando parejas.</p>
          <hr className="my-5 border-white/10" data-id="element-95" data-mp="2tx7okdjguarh" />
          <p className="font-sans text-xs uppercase tracking-[0.2em] text-white/50" data-id="element-96" data-mp="unj1pgl670nh">Respuesta inmediata</p>
          <a href={contact.whatsappHref} target="_blank" rel="noopener noreferrer" className="mt-2 block font-sans text-base font-semibold text-wa transition-colors duration-200 ease-smooth hover:text-white" data-id="element-97" data-mp="zmc3ibr3h37t">
            {contact.whatsappNumber}
          </a>
        </motion.div>
      </div>

      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 text-white/40" data-id="element-98" data-mp="9ah476xnerzr">
        <ArrowDownIcon className="h-5 w-5 animate-bounce" aria-hidden="true" data-id="element-99" data-mp="98e2hpn4vaf7" />
      </div>
    </section>;
}